/**
 * 導師服務頁 — 繁體中文（嵌套結構，對應 t('masterFortune.…')）
 */
export default {
	meta: {
		title: "全球1000+專家為你提供專業服務",
		keywords: "八字測試，真人八字測試",
		description:
			"先知命局，專業真人八字測試平台，為您提供權威、精準的測試服務。無論是八字命理分析、事業財運預測，還是感情婚姻指導，均由資深命理師在線一對一解讀。",
	},
	pageHeader: {
		breadcrumbHome: "首頁",
		breadcrumbCurrent: "更多導師",
		searchPlaceholder: "請輸入博主/老師昵稱搜索",
		searchButton: "搜尋",
	},
	index: {
		subBanner: {
			title: "「超百萬次鑑定實錄」",
			subtitle: "真實的口碑，安心的服務",
			defaultUserName: "宸***靈",
			starRatingAria: "評分 {score} 顆星",
			starAlt: "星星",
			emptyStarAlt: "空星星",
		},
		tags: [
			{ title: "超200萬", desc: "核心用戶" },
			{ title: "超99%", desc: "滿意率" },
			{ title: "4.96/5星", desc: "客戶評分" },
			{ title: "超200名", desc: "世界各地認證導師" },
		],
	},
	teacherResource: {
		ariaLabel: "推薦導師",
		title: "推薦導師",
		loading: "加載中...",
		empty: "暫無推薦導師",
		prevNav: "上一組導師",
		nextNav: "下一組導師",
		dotsAria: "老師列表分頁",
		pageAria: "第 {index} 頁",
		avatarAlt: "老師頭像",
		chatAria: "立即諮詢",
		defaultName: "老師",
		defaultSummary: "全能導師，用戶滿意度 99%",
		defaultTags: ["戀愛情感", "婚姻挽回"],
		viewDetail: "查看詳情",
		consultNow: "立即諮詢",
	},
	teacherRecommend: {
		ariaLabel: "推薦老師",
		title: "人氣導師",
		viewDetail: "查看詳情",
		consultNow: "立即諮詢",
		consultTeacher: "老師諮詢",
		loadMore: "加載更多 >",
		priceFrom: "起",
		consultCount: "{count} 人諮詢",
		sortOptions: {
			order_count: "按人氣排序",
			buy_total: "最熱門排序",
		},
		sortOptionsMobile: {
			order_count: "按人氣",
			buy_total: "最熱門",
		},
		themeOptions: {
			1: "綜合主題",
			2: "決策問事",
			3: "家庭健康",
			4: "事業財富",
			5: "愛情人際",
		},
	},
};
